export function formatPhone(value: string): string {
  const digits = value.replace(/\D/g, "").slice(0, 10)
  if (digits.length <= 3) return digits
  if (digits.length <= 6) return `(${digits.slice(0, 3)}) ${digits.slice(3)}`
  return `(${digits.slice(0, 3)}) ${digits.slice(3, 6)}-${digits.slice(6, 10)}`
}

export function isValidPhone(value: string): boolean {
  return /^[\d\s\-()+]+$/.test(value) && value.replace(/\D/g, "").length >= 10
}

// Consumer-entered phone → one canonical shape. US-only normalisation:
// a leading `1` on 11 digits is dropped (autofill pastes "+1 (555) 123-4567"),
// then formatted "(555) 123-4567". A `+` prefix that is NOT +1 is treated as
// international and passed through as E.164 (digits only after the `+`).
export interface NormalizedPhone {
  // What the input shows.
  display: string
  // What we send: 10 US digits, or "+<cc><number>" for non-US.
  e164: string
  valid: boolean
}

export function normalizePhone(raw: string): NormalizedPhone {
  const trimmed = raw.trim()
  const allDigits = trimmed.replace(/\D/g, "")
  const international = trimmed.startsWith("+") && !trimmed.startsWith("+1")
  if (international) {
    // ITU E.164: country code + subscriber, 8–15 digits total.
    const valid = allDigits.length >= 8 && allDigits.length <= 15
    return { display: `+${allDigits}`, e164: `+${allDigits}`, valid }
  }
  const national =
    allDigits.length === 11 && allDigits.startsWith("1") ? allDigits.slice(1) : allDigits
  const ten = national.slice(0, 10)
  return {
    display: formatPhone(ten),
    e164: ten,
    valid: ten.length === 10 && national.length === 10,
  }
}
